module.exports = __webpack_public_path__ + "img/lietuvos_institutas.0a0a9636.png";